<template>

  <v-sheet class="rounded pa-6 d-flex align-center">

    <!-- Query Parameter  -->
    <v-text-field
      ref         = "queryParameterField"
      class       = "mr-4"
      filled
      readonly
      hide-details
      :value      = "queryParameters"
    >
    </v-text-field>

    <!-- Copy To Clipboard -->
    <v-btn
      icon
      @click    = "onCopy"
    >
      <v-icon>mdi-content-copy</v-icon>
    </v-btn>

    <!-- Reset -->
    <v-btn
      icon
      @click    = "onReset"
    >
      <v-icon>mdi-arrow-u-left-top</v-icon>
    </v-btn>

  </v-sheet>

</template>

<script>

// #region Imports

/* Telestream */
import { LAYOUT_FLAGS, ACTION_FLAGS, TAB_IDS } from '@/utils/constants';

// #endregion Imports

export default {
  
  // #region Properties

  props: {
    layout: Object
  },
  computed: {
    queryParameters() {
      return `&${this.layoutQueryParam}&${this.actionsQueryParam}&${this.topTabsParam}&${this.bottomTabsParam}`;
    },
    layoutQueryParam() {
      let parameterValue = 0;

      parameterValue |= this.layout.header.visible && LAYOUT_FLAGS.HEADER_FLAG;
      parameterValue |= this.layout.fileToolbar.visible && LAYOUT_FLAGS.FILE_TOOLBAR_FLAG;
      parameterValue |= this.layout.videoPlayer.visible && LAYOUT_FLAGS.VIDEO_PLAYER_FLAG;
      parameterValue |= this.layout.timeline.visible && LAYOUT_FLAGS.TIMELINE_FLAG;
      parameterValue |= this.layout.topTabs.visible && LAYOUT_FLAGS.TOP_TABS_FLAG;
      parameterValue |= this.layout.bottomTabs.visible && LAYOUT_FLAGS.BOTTOM_TABS_FLAG;

      return `panes=${this.toHex(parameterValue)}`;
    },
    actionsQueryParam() {
      let parameterValue = 0;

      parameterValue |= this.layout.fileToolbar.actions.watchers && ACTION_FLAGS.WATCHERS_FLAG;
      parameterValue |= this.layout.fileToolbar.actions.cliplink && ACTION_FLAGS.CLIP_LINK_FLAG;
      parameterValue |= this.layout.fileToolbar.actions.close && ACTION_FLAGS.CLOSE_FLAG;
      parameterValue |= this.layout.fileToolbar.actions.browse && ACTION_FLAGS.BROWSE_FLAG;
      parameterValue |= this.layout.fileToolbar.actions.history && ACTION_FLAGS.HISTORY_FLAG;

      return `actions=${this.toHex(parameterValue)}`;
    },
    topTabsParam() {
      let parameterValue = this.layout.topTabs.locked ? 'ff' : '00';

      this.layout.topTabs.tabs.forEach(tab => {
        parameterValue += `,${this.toHex(TAB_IDS[tab])}`;
      });

      return `topTabs=${parameterValue}`;
    },
    bottomTabsParam() {
      let parameterValue = this.layout.bottomTabs.locked ? 'ff' : '00';

      this.layout.bottomTabs.tabs.forEach(tab => {
        parameterValue += `,${this.toHex(TAB_IDS[tab])}`;
      });

      return `bottomTabs=${parameterValue}`;
    }
  },

  // #endregion Properties

  // #region Methods

  methods: {

    onCopy() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.queryParameters);
      } else {
        this.$refs.queryParameterField.$el.querySelector('input').select();
        document.execCommand('copy');
      }
      
      this.$store.commit('SET_SNACK', {
        message: 'Query parameter copied to clipboard.',
        level:   'info',
      });
    },

    onReset() {
      this.$emit('reset');
    },

    // #region Utilities

    toHex(value) {
      return value.toString(16).padStart(2, '0');
    }

    // #endregion Utilities

  }

  // #endregion Methods

}

</script>